import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitTab'
})
export class SplitTabPipe implements PipeTransform {

  transform(text: string, index): unknown {
    var array=[];
    array = text.split(`/(\d+)/.-`);
    return array;
  }

}
